import React from 'react';
import SearchInputAlgolia from '../search-header/algoliaSearch';
import { useSearchParams } from 'next/navigation';

const NotFound = ({ query }: any) => {
  const searchParams = useSearchParams();
  const queryFromSearch: any = searchParams.get('q')?.split('?')[0];
  const isSearchPage = true;

  const searchTips = [
    'Please check spelling you used and try a search with a different spelling.',
    'Limit your search to one or two words.',
    'Try a less specific search as this is more likely to return some results.',
  ];

  const helpLinks = [
    {
      text: 'Click one of the headers at the top of the page or the buttons below to view a product category.',
      link: null,
    },
    {
      text: 'Click here for details of how to Contact Us.',
      link: 'https://help.americangolf.co.uk/hc/en-gb',
    },
    {
      text: 'Click here to visit our help section.',
      link: 'https://help.americangolf.co.uk/hc/en-gb',
    },
  ];

  return (
    <div className="my-40 flex flex-col items-center gap-y-10">
      <div className="flex w-full justify-center">
        <SearchInputAlgolia searchConfiguration={[]} searchPage={isSearchPage} />
      </div>

      <div className="mt-4 text-center">
        <span className="text-xl font-semibold">SORRY NO RESULTS FOUND FOR</span>
        <span className="mt-1 block text-lg font-medium">{queryFromSearch}</span>
      </div>

      <div className="mt-6 flex w-full max-w-4xl flex-col items-start justify-center gap-8 md:flex-row">
        <div className="flex-1 rounded-md bg-gray-100 p-4 shadow-md">
          <h3 className="mb-2 text-lg font-semibold">Search Tips</h3>
          <ul className="list-inside list-disc text-sm text-gray-700">
            {searchTips.map((tip, index) => (
              <li key={index}>{tip}</li>
            ))}
          </ul>
        </div>

        <div className="flex-1 rounded-md bg-gray-100 p-4 shadow-md">
          <h3 className="mb-2 text-lg font-semibold">Still need help?</h3>
          <ul className="list-inside list-disc text-sm text-gray-700">
            {helpLinks.map((help, index) => (
              <li key={index}>
                {help.link ? (
                  <a href={help.link} className="text-green-600 underline">
                    {help.text}
                  </a>
                ) : (
                  help.text
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
